export var EVENT_TYPE = /*#__PURE__*/function (EVENT_TYPE) {
  EVENT_TYPE["OPERATIONAL"] = "operational";
  EVENT_TYPE["SCREEN"] = "screen";
  EVENT_TYPE["TRACK"] = "track";
  EVENT_TYPE["UI"] = "ui";
  return EVENT_TYPE;
}({});
export var ACTION = /*#__PURE__*/function (ACTION) {
  ACTION["STARTED"] = "started";
  ACTION["RENDERED"] = "rendered";
  ACTION["CRASHED"] = "unhandledErrorCaught";
  ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
  ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
  ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
  ACTION["CLICKED"] = "clicked";
  ACTION["VIEWED"] = "viewed";
  ACTION["VISITED"] = "visited";
  ACTION["SORT_COLUMN"] = "sortedColumn";
  ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
  ACTION["TOGGLE_EXPAND"] = "toggleExpand";
  ACTION["INSERTED"] = "inserted";
  ACTION["OPENED"] = "opened";
  ACTION["CLOSED"] = "closed";
  ACTION["DELETED"] = "deleted";
  ACTION["EDITED"] = "edited";
  ACTION["RESOLVED"] = "resolved";
  ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
  ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
  ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
  ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
  ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
  return ACTION;
}({});
export var ACTION_SUBJECT = /*#__PURE__*/function (ACTION_SUBJECT) {
  ACTION_SUBJECT["RENDERER"] = "renderer";
  ACTION_SUBJECT["BUTTON"] = "button";
  ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
  ACTION_SUBJECT["TABLE"] = "table";
  ACTION_SUBJECT["EXPAND"] = "expand";
  ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
  ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
  ACTION_SUBJECT["LINK"] = "link";
  ACTION_SUBJECT["ANNOTATION"] = "annotation";
  ACTION_SUBJECT["MEDIA"] = "media";
  ACTION_SUBJECT["SMART_LINK"] = "smartLink";
  return ACTION_SUBJECT;
}({});
export var ACTION_SUBJECT_ID = /*#__PURE__*/function (ACTION_SUBJECT_ID) {
  ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
  ACTION_SUBJECT_ID["LINK"] = "link";
  ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
  ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
  ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
  ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
  return ACTION_SUBJECT_ID;
}({});